<template>
  <div class="h-100">
  <div v-if="isMobileTable && userDevices" class="h-100">
    <div class="datatable-body">
      <BulkActionsBar
        v-if="selectable"
        :count="selectedIds.length"
        :actions="bulkActions"
        @action="onBulkAction"
        @clear="clearSelection"
      />
      <div class="table-responsive datatable-table" ref="div">
        <table
          class="table table-striped table-bordered"
          style="width: 100%"
          v-if="!load"
        >
          <thead>
            <tr>
              <th v-if="selectable" class="dt-select-cell">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="allOnPageSelected"
                  :indeterminate.prop="someOnPageSelected && !allOnPageSelected"
                  @change="toggleSelectAllOnPage($event.target.checked)"
                />
              </th>
              <th
                v-for="(f, i) in fieldsMobile"
                :key="i"
                :style="f.style"
                :title="f.title"
                :colspan="1"
              >
                <div
                  :class="
                    f.orderby == null || f.orderby == true
                      ? 'orderby-header'
                      : 'no-orderby-header'
                  "
                >
                  <span style="font-size: 13px">{{ f.name }}</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in values" :key="i">
              <td v-if="selectable" class="dt-select-cell">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="isSelected(v.id)"
                  @change="toggleSelection(v.id, $event.target.checked)"
                />
              </td>
              <td v-for="(f, fi) in fieldsMobile" :key="fi">
                <div v-if="f.type == 'action'" class="row m-0">
                  <div style="display: flex; gap: 1rem">
                    <div v-if="f.edit" class="col-6">
                      <button
                        class="btn btn-white p-0"
                        @click="$emit('edit', v)"
                      >
                        <i class="bx bx-edit-alt text-primary"></i>
                      </button>
                    </div>
                    <div v-if="f.delete" class="col-6">
                      <button
                        class="btn btn-white p-0"
                        @click="$emit('delete', v.id)"
                      >
                        <i class="bx bx-trash text-danger"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else-if="f.type == 'toggle'" class="text-center">
                  <div class="form-check form-switch d-inline-block">
                    <input 
                      class="form-check-input" 
                      type="checkbox" 
                      :checked="v[f.value]" 
                      @change="$emit(f.toggleEvent, v)"
                    />
                  </div>
                </div>
                <div v-else-if="f.type == 'icon'" class="text-center">
                  <i 
                    :class="[
                      'bx', 
                      'bx-' + (f.formatter ? f.formatter(v[f.value], v) : ''),
                      f.formatterColor ? f.formatterColor(v[f.value], v) : ''
                    ]"
                  ></i>
                </div>
                <div v-for="(va, vai) in f.value" :key="vai">
                <div
                  style="display: block; font-size: 13px"
                  v-if="f.type == null"
                  v-html="f.format ? f.format(v[f.value[fi]], v) : v[va]"
                ></div>
                </div>
                <slot
                  v-if="f.type == 'slot'"
                  :name="f.value"
                  :value="v[f.value]"
                  :row="v"
                ></slot>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="h-100">
          <div v-if="error" class="h-100 d-flex">
            <div class="m-auto">
              <div class="mb-3">
                <span> Falha ao buscar </span>
              </div>
              <button class="btn btn-primary" @click="update">
                Recarregar
              </button>
            </div>
          </div>
          <div v-else class="h-100 d-flex">
            <div class="m-auto text-center">
              <div class="mb-3">
                <span>Buscando dados</span>
              </div>

              <div
                class="spinner-border spinner-border-lg text-primary"
                role="status"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center w-100 mt-5" v-if="values.length == 0 && !load">
          <h5>Nenhum dado encontrado</h5>
        </div>
      </div>
      <div class="mt-3 nav-foot">
        <div class="row m-0">
          <div class="col-md-6 col-12">
            <nav>
              <ul class="pagination">
                <li class="page-item">
                  <button class="page-link" @click="goToPage(page - 1)" v-show="page > 1">
                    <i
                      class="menu-icon tf-icons bx bx-chevron-left m-0 p-0"
                    ></i>
                  </button>
                </li>
                <li
                  :class="'page-item' + (p == page ? ' active' : '')"
                  v-for="(p, i) in getPages()"
                  :key="i"
                >
                  <button
                    class="page-link btn-nav-dt"
                    @click="page == p ? update() : goToPage(p)"
                  >
                    {{ p }}
                  </button>
                </li>
                <li class="page-item">
                  <button
                    class="page-link"
                    @click="goToPage(page + 1)"
                    v-show="page < maxPage"
                  >
                    <i
                      class="menu-icon tf-icons bx bx-chevron-right m-0 p-0"
                    ></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-md-6 text-end d-none d-md-inline-block">
            Mostrando {{ (page > 0 ? page - 1 : 0) * limit }} até
            {{ getPageInfo() }} de {{ max }} registros
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="shouldShowCards()" class="h-100">
    <!-- Cards Mode for Mobile -->
    <div class="datatable-body">
      <BulkActionsBar
        v-if="selectable"
        :count="selectedIds.length"
        :actions="bulkActions"
        @action="onBulkAction"
        @clear="clearSelection"
      />
      <div
        v-if="mobileSortOptions.length > 0"
        class="mobile-sort-bar mb-2"
      >
        <label class="mobile-sort-label">Ordenar por</label>
        <select
          class="form-select form-select-sm mobile-sort-select"
          :value="mobileSortValue"
          @change="onMobileSortChange($event.target.value)"
        >
          <option
            v-for="opt in mobileSortOptions"
            :key="opt.value"
            :value="opt.value"
          >
            {{ opt.label }}
          </option>
        </select>
      </div>
      <div class="cards-container" ref="div">
        <div v-if="!load">
          <div v-for="(item, index) in values" :key="index" class="datatable-card mb-3">
            <div class="card" :class="{ 'card-selected': selectable && isSelected(item.id) }">
              <div class="card-body">
                <div v-if="selectable" class="card-select-row mb-2">
                  <label class="form-check d-flex align-items-center gap-2 m-0">
                    <input
                      type="checkbox"
                      class="form-check-input mt-0"
                      :checked="isSelected(item.id)"
                      @change="toggleSelection(item.id, $event.target.checked)"
                    />
                    <span class="field-label">Selecionar</span>
                  </label>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div v-for="(field, fieldIndex) in fields" :key="fieldIndex" class="card-field mb-2">
                      <div v-if="field.type == 'action'" class="action-buttons-mobile">
                        <button
                          v-if="field.edit"
                          class="btn btn-outline-primary btn-mobile-action"
                          @click="$emit('edit', item)"
                        >
                          <i class="bx bx-edit-alt me-2"></i>
                          Editar
                        </button>
                        <button
                          v-if="field.delete"
                          class="btn btn-outline-danger btn-mobile-action"
                          @click="$emit('delete', item.id)"
                        >
                          <i class="bx bx-trash me-2"></i>
                          Excluir
                        </button>
                      </div>
                      <div v-else-if="field.type == 'toggle'" class="d-flex justify-content-between align-items-center">
                        <span class="field-label">{{ field.name }}:</span>
                        <div class="form-check form-switch">
                          <input 
                            class="form-check-input" 
                            type="checkbox" 
                            :checked="item[field.value]" 
                            @change="$emit(field.toggleEvent, item)"
                          />
                        </div>
                      </div>
                      <div v-else-if="field.type == 'icon'" class="d-flex justify-content-between align-items-center">
                        <span class="field-label">{{ field.name }}:</span>
                        <i 
                          :class="[
                            'bx', 
                            'bx-' + (field.formatter ? field.formatter(item[field.value], item) : ''),
                            field.formatterColor ? field.formatterColor(item[field.value], item) : ''
                          ]"
                        ></i>
                      </div>
                      <div v-else-if="field.type == 'date'" class="d-flex justify-content-between align-items-center">
                        <span class="field-label">{{ field.name }}:</span>
                        <span class="field-value" v-html="formatDate(item[field.value])"></span>
                      </div>
                      <div v-else-if="field.type == null && field.name" class="d-flex justify-content-between align-items-center">
                        <span class="field-label">{{ field.name }}:</span>
                        <span class="field-value" v-html="field.format ? field.format(item[field.value], item) : item[field.value]"></span>
                      </div>
                      <slot
                        v-else-if="field.type == 'slot'"
                        :name="field.value"
                        :value="item[field.value]"
                        :row="item"
                      ></slot>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="h-100">
          <div v-if="error" class="h-100 d-flex">
            <div class="m-auto text-center">
              <div class="mb-3">
                <span>Falha ao buscar</span>
              </div>
              <button class="btn btn-primary" @click="update">
                Recarregar
              </button>
            </div>
          </div>
          <div v-else class="h-100 d-flex">
            <div class="m-auto text-center">
              <div class="mb-3">
                <span>Buscando dados</span>
              </div>
              <div class="spinner-border spinner-border-lg text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center w-100 mt-3" v-if="values.length == 0 && !load">
          <h5>Nenhum dado encontrado</h5>
        </div>
      </div>
      <!-- Paginação para Cards -->
      <div class="mt-3 nav-foot">
        <div class="row m-0">
          <div class="col-12">
            <nav>
              <ul class="pagination justify-content-center">
                <li class="page-item">
                  <button class="page-link" @click="goToPage(page - 1)" v-show="page > 1">
                    <i class="menu-icon tf-icons bx bx-chevron-left m-0 p-0"></i>
                  </button>
                </li>
                <li
                  :class="'page-item' + (p == page ? ' active' : '')"
                  v-for="(p, i) in getPages()"
                  :key="i"
                >
                  <button
                    class="page-link btn-nav-dt"
                    @click="page == p ? update() : goToPage(p)"
                  >
                    {{ p }}
                  </button>
                </li>
                <li class="page-item">
                  <button
                    class="page-link"
                    @click="goToPage(page + 1)"
                    v-show="page < maxPage"
                  >
                    <i class="menu-icon tf-icons bx bx-chevron-right m-0 p-0"></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="h-100">
    <div class="datatable-body">
      <BulkActionsBar
        v-if="selectable"
        :count="selectedIds.length"
        :actions="bulkActions"
        @action="onBulkAction"
        @clear="clearSelection"
      />
      <div class="table-responsive datatable-table" ref="div">
        <table
          class="table table-striped table-bordered"
          style="width: 100%"
          v-if="!load"
        >
          <thead>
            <tr>
              <th v-if="selectable" class="dt-select-cell">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="allOnPageSelected"
                  :indeterminate.prop="someOnPageSelected && !allOnPageSelected"
                  @change="toggleSelectAllOnPage($event.target.checked)"
                />
              </th>
              <th
                v-for="(f, i) in fields"
                :key="i"
                :style="f.style"
                :title="f.title"
              >
                <div
                  :class="
                    f.orderby == null || f.orderby == true
                      ? 'orderby-header'
                      : 'no-orderby-header'
                  "
                >
                  <span>{{ f.name }}</span>
                  <button
                    class="btn btn-white p-0 btn-orderby"
                    @click="
                      orderby.type = 'ASC';
                      orderby.column = f.value;
                    "
                    v-if="
                      (f.orderby == null || f.orderby == true) &&
                      orderby.type == 'DESC'
                    "
                  >
                    <i class="bx bx-chevron-up"></i>
                  </button>
                  <button
                    class="btn btn-white p-0 btn-orderby"
                    @click="
                      orderby.type = 'DESC';
                      orderby.column = f.value;
                    "
                    v-if="
                      (f.orderby == null || f.orderby == true) &&
                      orderby.type == 'ASC'
                    "
                  >
                    <i class="bx bx-chevron-down"></i>
                  </button>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in values" :key="i" :class="{ 'row-selected': selectable && isSelected(v.id) }">
              <td v-if="selectable" class="dt-select-cell">
                <input
                  type="checkbox"
                  class="form-check-input"
                  :checked="isSelected(v.id)"
                  @change="toggleSelection(v.id, $event.target.checked)"
                />
              </td>
              <td v-for="(f, fi) in fields" :key="fi">
                <div v-if="f.type == 'action'" class="row m-0">
                  <div style="display: flex; gap: 1rem">
                    <div v-if="f.edit" class="col-6">
                      <button
                        class="btn btn-white p-0"
                        @click="$emit('edit', v)"
                      >
                        <i class="bx bx-edit-alt text-primary"></i>
                      </button>
                    </div>
                    <div v-if="f.delete" class="col-6">
                      <button
                        class="btn btn-white p-0"
                        @click="$emit('delete', v.id)"
                      >
                        <i class="bx bx-trash text-danger"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else-if="f.type == 'toggle'" class="text-center">
                  <div class="form-check form-switch d-inline-block">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="v[f.value]"
                      @change="$emit(f.toggleEvent, v)"
                    />
                  </div>
                </div>
                <div v-else-if="f.type == 'icon'" class="text-center">
                  <i
                    :class="[
                      'bx',
                      'bx-' + (f.formatter ? f.formatter(v[f.value], v) : ''),
                      f.formatterColor ? f.formatterColor(v[f.value], v) : ''
                    ]"
                  ></i>
                </div>
                <div
                  v-else-if="f.type == 'date'"
                  v-html="formatDate(v[f.value])"
                ></div>
                <div
                  v-else-if="f.type == null"
                  v-html="f.format ? f.format(v[f.value], v) : v[f.value]"
                ></div>
                <slot
                  v-else-if="f.type == 'slot'"
                  :name="f.value"
                  :value="v[f.value]"
                  :row="v"
                ></slot>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else class="h-100">
          <div v-if="error" class="h-100 d-flex">
            <div class="m-auto">
              <div class="mb-3">
                <span> Falha ao buscar </span>
              </div>
              <button class="btn btn-primary" @click="update">
                Recarregar
              </button>
            </div>
          </div>
          <div v-else class="h-100 d-flex">
            <div class="m-auto text-center">
              <div class="mb-3">
                <span>Buscando dados</span>
              </div>

              <div
                class="spinner-border spinner-border-lg text-primary"
                role="status"
              >
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center w-100 mt-5" v-if="values.length == 0 && !load">
          <h5>Nenhum dado encontrado</h5>
        </div>
      </div>
      <div class="mt-3 nav-foot">
        <div class="row m-0">
          <div class="col-md-6 col-12">
            <nav>
              <ul class="pagination">
                <li class="page-item">
                  <button class="page-link" @click="goToPage(page - 1)" v-show="page > 1">
                    <i
                      class="menu-icon tf-icons bx bx-chevron-left m-0 p-0"
                    ></i>
                  </button>
                </li>
                <li
                  :class="'page-item' + (p == page ? ' active' : '')"
                  v-for="(p, i) in getPages()"
                  :key="i"
                >
                  <button
                    class="page-link btn-nav-dt"
                    @click="page == p ? update() : goToPage(p)"
                  >
                    {{ p }}
                  </button>
                </li>
                <li class="page-item">
                  <button
                    class="page-link"
                    @click="goToPage(page + 1)"
                    v-show="page < maxPage"
                  >
                    <i
                      class="menu-icon tf-icons bx bx-chevron-right m-0 p-0"
                    ></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          <div class="col-md-6 text-end d-none d-md-inline-block">
            Mostrando {{ (page > 0 ? page - 1 : 0) * limit }} até
            {{ getPageInfo() }} de {{ max }} registros
          </div>
        </div>
      </div>
    </div>
  </div>

    <!-- Modal de Aviso: Perda de Seleção ao trocar de página -->
    <div class="modal fade" ref="modalLeaveSelection" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Você perderá sua seleção</h5>
            <button type="button" class="btn-close" @click="cancelLeaveSelection"></button>
          </div>
          <div class="modal-body">
            <p>
              Você tem <strong>{{ selectedIds.length }}</strong>
              {{ selectedIds.length === 1 ? 'item selecionado' : 'itens selecionados' }}.
            </p>
            <p class="text-muted small mb-0">
              Mudar de página vai limpar sua seleção atual. Deseja continuar?
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelLeaveSelection">
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" @click="confirmLeaveSelection">
              Continuar e limpar seleção
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BulkActionsBar from "./BulkActionsBar.vue";

export default {
  components: { BulkActionsBar },
  props: {
    url: { type: String },
    fields: { type: Array, default: () => [] },
    fieldsMobile: { type: Array, default: () => [] },
    where: { type: Object, default: () => ({}) },
    autoreload: { type: [Number, String], default: 0 },
    wait: { type: [Number, String], default: 0 },
    height: { type: [Number, String], default: null },
    iniorderby: { type: Object, default: null },
    minlimit: { type: [Number, String], default: null },
    userDevices: { type: Boolean, default: false },
    method: { type: String, default: null },
    mobileCardMode: { type: Boolean, default: false },
    selectable: { type: Boolean, default: false },
    bulkActions: { type: Array, default: () => [] },
  },
  data() {
    return {
      isMobileTable: false,
      run: null,
      values: [],
      limit: this.minlimit ? this.minlimit : 10,
      max: 0,
      page: 1,
      maxPage: 0,
      load: true,
      error: false,
      onLoad: false,
      selectedIds: [],
      pendingPage: null,
      orderby: this.iniorderby
        ? this.iniorderby
        : {
            column: null,
            type: "ASC",
          },
    };
  },
  computed: {
    mobileSortableFields() {
      const source = this.fieldsMobile && this.fieldsMobile.length > 0
        ? this.fieldsMobile
        : this.fields || [];
      return source.filter((f) => {
        if (f.orderby === false) return false;
        if (["action", "slot", "toggle", "icon"].includes(f.type)) return false;
        if (!f.name) return false;
        if (Array.isArray(f.value)) return false;
        return true;
      });
    },
    mobileSortOptions() {
      const opts = [];
      for (const f of this.mobileSortableFields) {
        opts.push({
          value: `${f.value}|DESC`,
          label: `${f.name} (Z → A)`,
          column: f.value,
          type: "DESC",
        });
        opts.push({
          value: `${f.value}|ASC`,
          label: `${f.name} (A → Z)`,
          column: f.value,
          type: "ASC",
        });
      }
      return opts;
    },
    mobileSortValue() {
      if (!this.orderby.column) return "";
      return `${this.orderby.column}|${this.orderby.type}`;
    },
    pageIds() {
      return this.values
        .map((v) => v.id)
        .filter((id) => id !== undefined && id !== null);
    },
    allOnPageSelected() {
      if (this.pageIds.length === 0) return false;
      return this.pageIds.every((id) => this.selectedIds.includes(id));
    },
    someOnPageSelected() {
      return this.pageIds.some((id) => this.selectedIds.includes(id));
    },
  },
  methods: {
    onMobileSortChange(value) {
      const opt = this.mobileSortOptions.find((o) => o.value === value);
      if (!opt) return;
      this.orderby.column = opt.column;
      this.orderby.type = opt.type;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
      } catch (e) {
        return dateString;
      }
    },
    getPageInfo() {
      var a = (this.page > 0 ? this.page - 1 : 0) * this.limit + this.limit;
      if (a > this.max) {
        return this.max;
      }
      return a;
    },
    applyFilters(filters) {
      for (const key in this.where) {
        delete this.where[key].value;
      }
      for (const key in filters) {
        if (this.where && this.where[key]) {
          if (filters[key] != null && filters[key] != "") {
            if (this.where[key].replace) {
              this.where[key].value = this.where[key].replace.replace(
                "{value}",
                filters[key]
              );
            } else {
              this.where[key].value = filters[key];
            }
          } else {
            this.where[key].value = null;
          }
        }
      }
      this.update();
    },
    getPages(p = this.isMobile() ? 3 : 5) {
      if (this.maxPage == 0) {
        return [];
      }
      if (this.maxPage == 1) {
        return [1];
      }
      var pages = [];
      var m = Math.floor(p / 2);
      var min = this.page - m;
      var max = this.page + Math.ceil(p / 2);
      pages.push(1);
      if (max > this.maxPage) {
        min = this.maxPage - p;
      }
      // console.log(max);
      var i = 0;
      var pg;
      do {
        pg = min + i++;
        if (pg > 1) {
          pages.push(pg);
        }
      } while (pg < this.maxPage - 1 && pages.length < p + 1);
      pages.push(this.maxPage);

      return pages;
    },
    computeSize(min = this.minlimit ? this.minlimit : 5) {
      var size = this.$refs.div.offsetHeight - 43;
      size = size / (this.height ? this.height : 50);
      if (size > min) {
        this.limit = Math.floor(size);
      } else {
        this.limit = min;
      }
    },
    getValues(load = true) {
      this.load = load;
      this.onLoad = true;
      this.error = false;
      var filter = {
        limit: this.limit,
        offset: (this.page > 0 ? this.page - 1 : 0) * this.limit,
        orderby: {},
        where: {},
      };
      var pageRe = this.page;
      if (this.where) {
        for (const key in this.where) {
          if (this.where[key].value != undefined) {
            filter.where[key] = this.where[key];
          }
        }
      }
      if (this.orderby.column != null) {
        filter.orderby[this.orderby.column] = this.orderby.type;
      }
      
      const apiMethod = this.method === 'post' ? this.crudPost : this.crudList;
      
      apiMethod(this.url, filter)
        .then((res) => {
          if (this.page != pageRe) {
            return;
          }
          this.load = false;
          this.values = res.data.itens;
          this.max = res.data.max;
          // Página que o usuário passa a ver (ex.: histórico marca como lido o que foi exibido).
          this.$emit("loaded", this.values);
          if (this.selectable && this.selectedIds.length > 0) {
            const visibleIds = new Set(
              this.values
                .map((v) => v.id)
                .filter((id) => id !== undefined && id !== null)
            );
            this.selectedIds = this.selectedIds.filter((id) => visibleIds.has(id));
          }
        })
        .catch((e) => {
          this.error = true;
        })
        .finally((e) => {
          this.onLoad = false;
        });
    },
    update() {
      this.getValues();
    },
    isSelected(id) {
      return this.selectedIds.includes(id);
    },
    toggleSelection(id, checked) {
      if (id === undefined || id === null) return;
      if (checked) {
        if (!this.selectedIds.includes(id)) {
          this.selectedIds.push(id);
        }
      } else {
        this.selectedIds = this.selectedIds.filter((s) => s !== id);
      }
    },
    toggleSelectAllOnPage(checked) {
      if (checked) {
        const merged = new Set([...this.selectedIds, ...this.pageIds]);
        this.selectedIds = Array.from(merged);
      } else {
        this.selectedIds = this.selectedIds.filter(
          (id) => !this.pageIds.includes(id)
        );
      }
    },
    clearSelection() {
      this.selectedIds = [];
    },
    goToPage(target) {
      if (target === this.page) return;
      // Trocar de página descarta a seleção atual (só os itens visíveis permanecem
      // marcados). Avisa o usuário antes de perder a seleção, como no bulk de leituras.
      if (this.selectable && this.selectedIds.length > 0) {
        this.pendingPage = target;
        // appendTo("body") + z-index acima do backdrop (1050): caso contrário o modal
        // fica preso no fluxo do componente e o backdrop cobre o conteúdo. Mesmo padrão do Crud.vue.
        $(this.$refs.modalLeaveSelection).appendTo("body");
        $(this.$refs.modalLeaveSelection).css("z-index", "1051");
        $(this.$refs.modalLeaveSelection).modal({ backdrop: "static", keyboard: false, show: true });
        return;
      }
      this.page = target;
    },
    hideLeaveSelectionModal() {
      $(this.$refs.modalLeaveSelection).modal("hide");
      setTimeout(() => {
        $(this.$refs.modalLeaveSelection).appendTo(this.$el);
      }, 500);
    },
    confirmLeaveSelection() {
      const target = this.pendingPage;
      this.pendingPage = null;
      this.hideLeaveSelectionModal();
      this.clearSelection();
      if (target != null) {
        this.page = target;
      }
    },
    cancelLeaveSelection() {
      this.pendingPage = null;
      this.hideLeaveSelectionModal();
    },
    onBulkAction(action) {
      if (!action || !action.event) return;
      this.$emit(action.event, [...this.selectedIds]);
    },
    checkScreenSize() {
      this.isMobileTable = window.innerWidth < 588;
    },
    shouldShowCards() {
      return this.mobileCardMode && this.isMobile();
    },
    getColspan(index) {
      if (index >= 1 && index <= 3) {
        return 3;
      } else {
        return 1;
      }
    },
    getRowspan(index) {
      if (index === 1) {
        return 3;
      } else {
        return 1;
      }
    },
    isMobile() {
      return window.innerWidth < 768;
    }
  },

  mounted() {
    if (this.wait) {
      setTimeout(() => {
        this.computeSize();
        this.getValues();
      }, this.wait);
    } else {
      this.computeSize();
      this.getValues();
    }
    if (this.autoreload > 0) {
      this.run = setInterval(() => {
        if (!this.onLoad) {
          this.getValues(false);
        }
      }, this.autoreload);
    }
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  watch: {
    max(v) {
      this.maxPage = Math.ceil(v / this.limit);
      if (this.page > this.maxPage) {
        this.page = this.maxPage;
      }
    },
    page(page) {
      this.update();
    },
    "orderby.type"() {
      this.update();
    },
    "orderby.column"() {
      this.update();
    },
  },
  beforeUnmount() {
    clearInterval(this.run);
    window.removeEventListener("resize", this.checkScreenSize);
    // Garante que o modal reanexado ao body não vaze se o componente for destruído
    // (ex.: troca de aba) enquanto o modal/backdrop ainda estiver aberto.
    if (this.$refs.modalLeaveSelection) {
      $(this.$refs.modalLeaveSelection).modal("hide");
      $(this.$refs.modalLeaveSelection).remove();
    }
    $(".modal-backdrop").remove();
  },
};
</script>

<style>
.card-title-datatable {
  display: inline-block;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.btn-nav-dt {
  line-height: 20px;
}

.datatable-table {
  min-height: calc(100% - 50px);
  height: calc(100% - 50px);
  max-height: calc(100% - 50px);
  overflow-y: auto;
}
.nav-foot {
  overflow: auto;
}
.no-orderby-header {
  line-height: 26px;
}
.orderby-header {
  display: flex;
  vertical-align: bottom;
}
.orderby-header span {
  line-height: 24px;
}
.btn-orderby {
  margin-left: auto;
  margin-right: 0px;
}
.datatable-body {
  height: 100%;
}
.form-check.form-switch {
  padding-left: 0;
}
.form-check-input {
  cursor: pointer;
}

/* Estilos para Cards no Mobile */
.cards-container {
  min-height: calc(100% - 50px);
  height: calc(100% - 50px);
  max-height: calc(100% - 50px);
  overflow-y: auto;
  padding: 0.5rem;
}

.datatable-card .card {
  border: 1px solid #e3e6f0;
  border-radius: 0.35rem;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
  transition: all 0.3s;
}

.datatable-card .card:hover {
  box-shadow: 0 0.25rem 2rem 0 rgba(58, 59, 69, 0.2);
}

.datatable-card .card-body {
  padding: 1rem;
}

.datatable-card .field-label {
  font-weight: 600;
  color: #5a5c69;
  font-size: 0.875rem;
}

.datatable-card .field-value {
  color: #3a3b45;
  font-size: 0.875rem;
  word-break: break-word;
}

.datatable-card .btn-group {
  gap: 0.25rem;
}

.datatable-card .btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.action-buttons-mobile {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e3e6f0;
}

.btn-mobile-action {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: 0.375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.btn-mobile-action:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.mobile-sort-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 4px;
}
.mobile-sort-label {
  font-size: 0.85rem;
  color: #566a7f;
  margin: 0;
  flex-shrink: 0;
}
.mobile-sort-select {
  flex: 1 1 auto;
}

.dt-select-cell {
  width: 40px;
  text-align: center;
  vertical-align: middle;
}
.dt-select-cell .form-check-input {
  margin: 0;
  cursor: pointer;
}
tr.row-selected td {
  background-color: rgba(40, 167, 69, 0.08) !important;
}
.datatable-card .card.card-selected {
  border-color: #28a745;
  box-shadow: 0 0 0 2px rgba(40, 167, 69, 0.15);
}
.card-select-row {
  border-bottom: 1px solid #e3e6f0;
  padding-bottom: 0.5rem;
}
</style>
